import { Dialog, DialogContent, DialogHeader, DialogOverlay, DialogTitle } from "@/components/ui/dialog";
import VideoPlayer from "@/components/videoPlayer/VideoPlayer";
import { useSelector, useDispatch } from "react-redux";
import { SET_VIDEOPLAYEROPEN, SET_VIEWVIDEO } from "@/redux/features/music/musicSlice";
import { useEffect } from "react";

export default function VideoPlayerDialog() {
  const { videoPlayerOpen, viewVideo } = useSelector((state) => state.music);
  const dispatch = useDispatch();

  const cleanupPointerEvents = () => {
    document.body.style.removeProperty('pointer-events');
    document.body.style.cursor = 'auto';
  };

  const handleOpenChange = (value) => {
    if (!value) {
      dispatch(SET_VIDEOPLAYEROPEN(false));
      dispatch(SET_VIEWVIDEO(null));
      cleanupPointerEvents();
    }
  };

  // Ensure cleanup is called on dialog close events
  const dialogCloseHandler = () => {
    cleanupPointerEvents();
  };

  // Add cleanup on unmount
  useEffect(() => {
    return () => {
      cleanupPointerEvents();
    };
  }, []);

  return (
    <Dialog open={videoPlayerOpen} onOpenChange={handleOpenChange}>
      <DialogOverlay className="z-[99] bg-black/60 backdrop-blur-lg ">
        <DialogContent 
          className="sm:max-w-max max-h-[95vh] w-[92%] sm:w-[95%] border-none dark:border-pink-500/30 z-[999] bg-transparent px-1 py-1"
          style={{ pointerEvents: 'auto' }}
          onCloseAutoFocus={dialogCloseHandler}
          onEscapeKeyDown={dialogCloseHandler}
          onInteractOutside={dialogCloseHandler}
        >
          <DialogHeader>
            <DialogTitle className="text-green-400 dark:text-pink-500 text-2xl font-bold tracking-tight"></DialogTitle>
          </DialogHeader>
          <div className="flex justify-center items-center w-full">
            <VideoPlayer video={viewVideo} />
          </div>
        </DialogContent>
      </DialogOverlay>
    </Dialog>
  );
}
